import { render } from "./batch-apply.vue?vue&type=template&id=bbcc0374&scoped=true"
import script from "./batch-apply.vue?vue&type=script&lang=js"
export * from "./batch-apply.vue?vue&type=script&lang=js"

import "./batch-apply.vue?vue&type=style&index=0&id=bbcc0374&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbcc0374"]])

export default __exports__